import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {
  BLOCK_ENTITY_PARAM_MODIFIER,
  BLOCK_MODULE_NAMESPACE,
  BLOCK_RECORD,
  BLOCK_RESET,
  BLOCK_SET_PAREMETER,
  BLOCK_UPDATE
} from '../../store/block';
import {ActivityStatus, CrudStatus} from '../../common/enums';
import {
  APARTMENT_MODULE_NAMESPACE,
  APARTMENT_RECORD_APPARTMENT,
  APARTMENT_RESET_APPARTMENT,
  APARTMENT_SET_APPARTMENTS_PARAMETER_PARTIAL,
  APARTMENT_SET_ZONE_ACTION,
  APARTMENT_UPDATE_APARTMENT
} from '../../store/apartment';
import {IApartment, IApartmentParameter} from '../../models/apartment';
import {IBlock, IBlockParameter} from '../../models/block';
import {IBaseFilterParameter} from '../../models/base-filter.parameter';
import {AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE} from '../../store/authorization';
import {TranslateResult} from 'vue-i18n';
import {
  PROFILE_MODULE_NAMESPACE,
  PROFILE_RESET_MEMBER,
  PROFILE_UPDATE_MEMBER
} from '../../store/profile/profile-types.store';
import {TICKET_GET_TICKET_PROBLEM_TYPE, TICKET_MODULE_NAMESPACE} from '../../store/ticket';
// @ts-ignore
import {
  EQUIPMENT_PARAMETER,
  EQUIPMENT_RECORD,
  EQUIPMENT_RESET,
  EQUIPMENT_SET_BY_FIELD,
  EQUIPMENT_UPDATE,
  MAINTENANCE_INIT_FIELDS,
  MAINTENANCE_MODULE_NAMESPACE,
  MAINTENANCE_PATCH_UPDATE,
  MAINTENANCE_POST_CREATE,
  MAINTENANCE_SET_SEARCHPARAMS,
  VEHICLE_FLEET_PARAMETER
} from '../../store/maintenance'
import {IEquipment} from "../../models/equipment/equipment.model";
import { IDocumentParamter } from '../../models/documents';
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_SET_DOCUMENT_PARAMETER } from '../../store/document';
import { IMaintenanceSearchParams } from '../../store/maintenance/maintenance-state.store';
import { eventBus } from '../../main';

const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const ProfileStore= namespace(PROFILE_MODULE_NAMESPACE)
const AuthorizationStore= namespace(AUTHORIZATION_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE);
const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE);
const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)
@Component({
  components: {
    'block-modal-vertical': async () => import('./components/block-modal-vertical/BlockModalVertical.vue'),
    'apartment-modal-vertical': async () => import('./components/block-apartment-vertical-modal/BlockApartmentVerticalModal.vue'),
    'profile-modal-vertical': async () => import('../profile/components/profile-modal-vertical/ProfileModalVertical.vue'),
    'equipment-modal-vertical': async () => import('./components/block-equipment-modal-vertical/BlockEquipmentModalVertical.vue'),
    'maintenance-modal-vertical': async () => import('./components/block-maintenance-modal-vertical/BlockMaintenanceModalVertical.vue')
  }
})
class BlockContainer extends Vue {

  dtError: any;
  dtErrorModalVisible: boolean;
  dtSuccess: boolean;
  dtBlockModalVisible: boolean;
  dtEquipmentModalVisible: boolean;
  dtMaintenanceModalVisible: boolean;
  dtApartmentModalVisible: boolean;
  dtApartmentCreateAnother: boolean;
  dtBlockId: number | null;
  dtIsRecording: boolean;
  dtIsRecordingCreateApartment: boolean;
  dtProfileModalVisible: boolean;

  maintenanceData:any
  isUpdateMaintenance:boolean
  isScheludeEquipmentMaintenance:boolean
  equipmentIcon:string
  isVehicle:boolean

  constructor(){
    super()

    this.dtBlockModalVisible= false
    this.dtEquipmentModalVisible= false
    this.dtMaintenanceModalVisible= false
    this.dtApartmentModalVisible= false
    this.dtIsRecording= false
    this.dtIsRecordingCreateApartment= false
    this.dtErrorModalVisible= false
    this.dtApartmentCreateAnother= false
    this.dtBlockId= null
    this.dtError= null
    this.dtSuccess= false
    this.dtProfileModalVisible= false
    this.maintenanceData = {}
    this.isUpdateMaintenance = false
    this.isScheludeEquipmentMaintenance = false
    this.equipmentIcon = 'handyman'
    this.isVehicle = false
  }

  @BlockStore.Getter activityStatus: ActivityStatus;
  @BlockStore.Getter detailActivityStatus: ActivityStatus;
  @BlockStore.Getter blockParameter: IBlockParameter;
  @BlockStore.Getter blockEntityParameter: IBaseFilterParameter & { q: string };
  @BlockStore.Getter blockCrudActionStatus: CrudStatus;
  @Watch('blockCrudActionStatus')
  onCrudActionChange(newVal: CrudStatus ){
     if(newVal === CrudStatus.Update ) this.dtBlockModalVisible= true
  }
  @ApartmentStore.Getter apartmentParameter: IApartmentParameter;
  @ApartmentStore.Getter apartmentCrudActionStatus: CrudStatus
  @Watch('apartmentCrudActionStatus')
  onApartmentCrudActionChange(newVal: CrudStatus){
    if(newVal === CrudStatus.Update ) this.handleAddApartment(this.$route.params.id)
  }
  @ProfileStore.Getter profileCrudActionStatus: CrudStatus
  @Watch('profileCrudActionStatus')
  onProfileCrudActionChange(newVal: CrudStatus){
    if(newVal === CrudStatus.Update) this.handleAddMember()
  }
  @MaintenanceStore.Getter equipmentCrudActionStatus: CrudStatus
  @Watch('equipmentCrudActionStatus')
  onEquipmentCrudActionStatusChange(newVal: CrudStatus) {
    if(newVal === CrudStatus.Update) this.handleAddEquipment()
  }
  @MaintenanceStore.Getter equipment: IEquipment;
  @MaintenanceStore.Getter currentEquipment: any;
  @MaintenanceStore.Getter blockEquipmentParameter: any;
  @MaintenanceStore.Getter blockVehicleFleetParameter: any;

  @ApartmentStore.Mutation(APARTMENT_SET_APPARTMENTS_PARAMETER_PARTIAL)
  storeSetApartmentParamter: (parameter: IApartmentParameter) => void;

  @ApartmentStore.Mutation(APARTMENT_SET_ZONE_ACTION)
  storeSetZoneAction: (action: CrudStatus) => void;
  @BlockStore.Mutation(BLOCK_SET_PAREMETER)
  storeSetBlockParamter: (parameter: IBlockParameter) => void;
  @BlockStore.Mutation(BLOCK_ENTITY_PARAM_MODIFIER)
  storeSetEntityKeyword: (option: { q: string }) => void;
  @MaintenanceStore.Mutation(EQUIPMENT_SET_BY_FIELD)
  storeAssignValueForEquipment: (payload: IEquipment) => void;
  @MaintenanceStore.Mutation(EQUIPMENT_PARAMETER)
  storeSetBlockEquipmentParameter: (payload: any)=> void;

  @MaintenanceStore.Mutation(VEHICLE_FLEET_PARAMETER)
  storeSetBlockVehicleFleetParameter: (payload: any)=> void;

  @MaintenanceStore.Mutation(MAINTENANCE_INIT_FIELDS)
  storeMaintenanceInitFields: () => void;

  @MaintenanceStore.Action(MAINTENANCE_POST_CREATE)
  storeCreateMaintenance: () => Promise<any>

  @MaintenanceStore.Action(MAINTENANCE_PATCH_UPDATE)
  storeUpdateMaintenance: (id:string) => Promise<any>

  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;
  @BlockStore.Action(BLOCK_RESET)
  storeResetBlock: () => void
  @ApartmentStore.Action(APARTMENT_RESET_APPARTMENT)
  storeResetApartment: () => void
  @BlockStore.Action(BLOCK_RECORD)
  storeRecordBlock: () => Promise<any>
  @BlockStore.Action(BLOCK_UPDATE)
  storeUpdateBlock: () => Promise<any>
  @ApartmentStore.Action(APARTMENT_RECORD_APPARTMENT)
  storeRecordApartment: (payload: { keepAlive?: boolean } ) => Promise<any>
  @ApartmentStore.Action(APARTMENT_UPDATE_APARTMENT)
  storeUpdateApartment: () => Promise<any>
  @ProfileStore.Action(PROFILE_RESET_MEMBER)
  storeResetMember: () => void
  @ProfileStore.Action(PROFILE_UPDATE_MEMBER)
  storeUpdateMember: (payload?: {own : boolean }) => Promise<any>
  @TicketStore.Action(TICKET_GET_TICKET_PROBLEM_TYPE)
  storeGetTicketProblemType: () => void;
  @MaintenanceStore.Action(EQUIPMENT_RESET)
  storeResetEquipment: () => void
  @MaintenanceStore.Action(EQUIPMENT_RECORD)
  storeRecordEquipment: () => Promise<any>
  @MaintenanceStore.Action(EQUIPMENT_UPDATE)
  storeUpdateEquipment: () => Promise<any>
  @DocumentStore.Getter documentParameter: IDocumentParamter
  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (payload: IDocumentParamter) => void


  @MaintenanceStore.Getter maintenanceSearchParams:IMaintenanceSearchParams
  @MaintenanceStore.Mutation(MAINTENANCE_SET_SEARCHPARAMS)
  storeMaintenancesSearchParams: (params:IMaintenanceSearchParams) => void;

  mounted() {
    //alert('mounted block container')
    this.storeGetFunctionalities('block')
    .then( response => {
       if(this.$route.meta) Object.keys(response).forEach( key => this.$route.meta[key] = true )
       Promise.all([
         this.storeGetFunctionalities('block_apartments'),
         this.storeGetFunctionalities('profile'),
         this.storeGetFunctionalities('block_maintenance'),
         this.storeGetFunctionalities('block_vehicle_fleet')
       ])
        .then(responses => {
            if(this.$route.meta) Object.keys({ ...responses[0], ...responses[1], ...responses[2], ...responses[3] }).forEach(key => this.$route.meta[key] = true )
        })
        .catch(err=> console.log('error get functionalities',err) )
    })
    this.storeGetTicketProblemType()
  }

  updated() {
    //alert('updated block container')
  }

  beforeMount(){
    eventBus.$on('OPEN_MAINTENANCE_MODAL',(data)=>{
      console.log('OPEN_MAINTENANCE_MODAL', {data})
      this.maintenanceData = data.maintenance
      this.isUpdateMaintenance = true
      this.$nextTick(()=>{
        this.handleAddmaintenance()
      })
    })

    eventBus.$on('SCHEDULE_MAINTENANCE_EQUIPMENT',(data)=>{
      console.log('SCHEDULE_MAINTENANCE_EQUIPMENT',{data})
      this.maintenanceData = {
        FKEquipmentCategory:data.categoryId,
        FKEquipmentSubCategory:data.subCategoryId,
        FKEquipment:data.equipmentId
      }
      this.isScheludeEquipmentMaintenance = true
      this.$nextTick(()=>{
        this.handleAddmaintenance()
      })
    })


  }

  beforeDestroy(){
    eventBus.$off('OPEN_MAINTENANCE_MODAL')
    eventBus.$off('SCHEDULE_MAINTENANCE_EQUIPMENT')
  }

  get loading(): boolean {
    return this.activityStatus === ActivityStatus.Loading || this.detailActivityStatus === ActivityStatus.Loading;
  }

  get coKeyword(): string {
    if (this.$route.path.indexOf('apartment') > -1) {
      return this.apartmentParameter.key;
    } else if (this.$route.path.endsWith('equipment')) {
      return this.blockEquipmentParameter.q
    } else if(this.$route.name === 'block_vehicle_fleet'){
      return this.blockVehicleFleetParameter.q
    }
    else if (this.$route.name === 'block') {//(this.$route.path.endsWith('block')  || this.$route.path.endsWith('block/')) {
      return this.blockParameter.key;
    } else if (this.$route.path.indexOf('contact') > -1 ) {
      return this.blockEntityParameter.q;
    } else if (this.$route.path.indexOf('document') > -1) {
      return this.documentParameter.key
    } else if (this.$route.path.indexOf('maintenance') > -1){
      return this.maintenanceSearchParams.q
    }
    return null
  }

  set coKeyword(value: string) {
    // TODO TO CHANGE
    if (this.$route.path.indexOf('apartment') > -1) {
      this.storeSetApartmentParamter({ key: value });
    } else if (this.$route.path.endsWith('equipment')) {
      this.storeSetBlockEquipmentParameter({ q: value });
    } else if (this.$route.name === 'block_vehicle_fleet') {
      this.storeSetBlockVehicleFleetParameter({ q: value });
    } else if (this.$route.name === 'block') {//(this.$route.path.endsWith('block')  || this.$route.path.endsWith('block/')) {
      this.storeSetBlockParamter({ key: value });
    } else if (this.$route.path.indexOf('contact') > -1 ) {
      this.storeSetEntityKeyword({ q: value })
    } else if (this.$route.path.indexOf('document') > -1){
      this.storeSetDocumentParameter({key: value})
    } else if (this.$route.path.indexOf('maintenance') > -1){
      this.storeMaintenancesSearchParams({
        ...this.maintenanceSearchParams,
        $limit:10,
        $skip:0,
        q:value
      })
      eventBus.$emit('SEARCH_MAINTENANCE_BY_KEYWORD',value)
    }
  }


  get searchVisible(): boolean {
    if (this.$route.path.endsWith('apartment')) {
      return true
    } else if (this.$route.path.endsWith('equipment')) {
      return true
    } else if (this.$route.name === 'block') {//(this.$route.path.endsWith('block') || this.$route.path.endsWith('block/')) {
      return true
    } else if(this.$route.name === 'block_detail') {
      return false
    } else if (this.$route.path.indexOf('contact') > -1 ) {
      return true
    } else if(this.$route.path.indexOf('document') > -1 ) {
      return true
    } else if(this.$route.path.indexOf('maintenance') > -1 && this.$route.path, this.$route.path.split('/').length==4) {
      return true
    }
    return false
  }


  get lblSetting() {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/apartment').default,
      ...require('@/locales/profile').default,
      ...require('@/locales/equipment').default,
      ...require('@/locales/button').default,
      ...require('@/locales/maintenance').default,
      ...require('@/locales/document').default,
    }
  }

  get isUpdateAction(): boolean {
    return this.blockCrudActionStatus === CrudStatus.Update ||
      this.apartmentCrudActionStatus === CrudStatus.Update ||
      this.equipmentCrudActionStatus === CrudStatus.Update
  }

  get coBlockModalVisible(): boolean {
    return this.blockCrudActionStatus === CrudStatus.Update || this.blockCrudActionStatus === CrudStatus.Create
  }

  get memberModalTitle() : TranslateResult {
    return this.$t(this.lblSetting.profileMemberUpdate)
  }

  get memberMaxWidth(): string {
    return `${document.body.clientWidth * 0.85}px`;
  }

  get memberButtonText() :TranslateResult {
    return this.$t(this.lblSetting.btnUpdate)
  }

  /* modal properties - BEGIN  */
  get blockMaxWidth(): string {
    return `${document.body.clientWidth * 0.9}px`;
  }

  get apartmentMaxWidth(): string {
    return `${document.body.clientWidth * 0.9}px`
  }

  get maintenanceMaxWidth(): string {
    return `${document.body.clientWidth * 0.9}px`
  }

  get blockModalTitle() : TranslateResult {
    return this.isUpdateAction ? this.$t(this.lblSetting.blockUpdate) : this.$t(this.lblSetting.blockCreate)
  }

  get apartmentModalTitle() : TranslateResult {
    return this.isUpdateAction ? this.$t(this.lblSetting.apartmentUpdate) : this.$t(this.lblSetting.apartmentCreate)
  }

  get equipmentModalTitle() : TranslateResult {
    switch(this.$route.name)
    {
      case 'block_equipment':
      case 'block_equipment_details':
        return this.isUpdateAction ? this.$t(this.lblSetting.equipmentModal.update) : this.$t(this.lblSetting.equipmentModal.create)
      case 'block_vehicle_fleet':
      case 'block_vehicle_details':
        return this.isUpdateAction ? this.$t(this.lblSetting.vehicleModal.update) : this.$t(this.lblSetting.vehicleModal.create)
    }
  }

  get maintenanceModalTitle() : TranslateResult {
    return this.isUpdateMaintenance ? this.$t(this.lblSetting.maintenanceModal.update) : this.$t(this.lblSetting.maintenanceModal.create)
  }

  get buttonText() : TranslateResult {
    return this.isUpdateAction ? this.$t(this.lblSetting.btnUpdate) : this.$t(this.lblSetting.blockSave)
  }

  get manageZone () {
    if (!localStorage.getItem('block_apartment_details')) return false
    return JSON.parse(localStorage.getItem('block_apartment_details')).manage_apartment_zone || false
  }

  get canAddMaintenance () {
    if (!localStorage.getItem('block_maintenance')) return false
    return JSON.parse(localStorage.getItem('block_maintenance')).add_maintenance || false
  }

  get canAddDocument () {
    if (!localStorage.getItem('block_detail')) return false
    return JSON.parse(localStorage.getItem('block_detail')).create_document || false
  }

  get hideAddButton () {
    switch (this.$route.path) {
      case `/block`:
        return !this.$route.meta['add_block']
      /* case `/block/${this.$route.params.id}/ticket`:
        return !this.$route.meta['create_ticket'] */
      case `/block/${this.$route.params.id}`:
      case `/block/${this.$route.params.id}/apartment`:
        return !this.$route.meta['add_apartment']
      case `/block/${this.$route.params.id}/equipment`:
      case `/block/${this.$route.params.id}/equipment/${this.$route.params.cid}`:
      case `/block/${this.$route.params.id}/vehicleFleet`:
      case `/block/${this.$route.params.id}/vehicle/${this.$route.params.cid}`:
        return !this.$route.meta['manage_equipment']
      case `/block/${this.$route.params.id}/apartment/${this.$route.params.cid}/zones`:
        return !this.manageZone
      case `/block/${this.$route.params.id}/maintenance`:
      case `/block/${this.$route.params.id}/maintenance/${this.$route.params.cid}`:
        return !this.canAddMaintenance
      case `/block/${this.$route.params.id}/document`:
        return !this.canAddDocument
      default:
        return true
    }
  }


  get AddButtonToolTip () {
    switch (this.$route.path) {
      case `/block`:
        return this.$t(this.lblSetting.blockCreate)
      case `/block/${this.$route.params.id}`:
      case `/block/${this.$route.params.id}/apartment`:
        return this.$t(this.lblSetting.apartmentCreate)
      case `/block/${this.$route.params.id}/equipment`:
      case `/block/${this.$route.params.id}/equipment/${this.$route.params.cid}`:
        return this.$t(this.lblSetting.equipmentModal.create)
      case `/block/${this.$route.params.id}/vehicleFleet`:
      case `/block/${this.$route.params.id}/vehicle/${this.$route.params.cid}`:
        return this.$t(this.lblSetting.vehicleModal.create)
/*       case `/block/${this.$route.params.id}/apartment/${this.$route.params.cid}/zones`:
        return !this.manageZone */
      case `/block/${this.$route.params.id}/maintenance`:
      case `/block/${this.$route.params.id}/maintenance/${this.$route.params.cid}`:
        return this.$t(this.lblSetting.maintenanceModal.create)
      case `/block/${this.$route.params.id}/document`:
        return this.$t(this.lblSetting.documentAdd)
      default:
        return true
    }
  }

  handleOpenModal() {
    switch (this.$route.path) {
      case `/block`:
        return this.handleAddBlock()
      case `/block/${this.$route.params.id}`:
      case `/block/${this.$route.params.id}/apartment`:
        return this.handleAddApartment(this.$route.params.id)
      case `/block/${this.$route.params.id}/equipment`:
      case `/block/${this.$route.params.id}/equipment/${this.$route.params.cid}`:
      case `/block/${this.$route.params.id}/vehicleFleet`:
      case `/block/${this.$route.params.id}/vehicle/${this.$route.params.cid}`:
        return this.handleAddEquipment()
      case `/block/${this.$route.params.id}/apartment/${this.$route.params.cid}/zones`:
        return this.handleAddZone()
      case `/block/${this.$route.params.id}/maintenance`:
      case `/block/${this.$route.params.id}/maintenance/${this.$route.params.cid}`:
        return this.handleAddmaintenance()
      case `/block/${this.$route.params.id}/document`:
        return eventBus.$emit('BLOCK_CREATE_DOCUMENT')
      default:
        return () => {}
    }
  }

  handleAddBlock(){
    this.dtBlockModalVisible = true;
  }

  handleAddEquipment() {
    if(this.$route.name === 'block_vehicle_fleet' || this.$route.name === 'block_vehicle_details')
    {
      this.equipmentIcon = 'drive_eta'
      this.isVehicle = true
    }else{
      this.equipmentIcon = 'handyman'
      this.isVehicle = false
    }
    this.dtEquipmentModalVisible = true;
  }

  handleAddmaintenance()
  {
    this.dtMaintenanceModalVisible = true;
  }

  handleAddApartment(blockId: string | number ){
    this.dtBlockId= typeof blockId === 'number' ? blockId : parseInt(blockId)
    this.dtApartmentModalVisible = true;
  }

  handleAddMember(){
    this.dtProfileModalVisible= true
  }

  handleAddZone() {
    this.storeSetZoneAction(CrudStatus.Create)
  }

  handleSaveBlock(createApartment?: boolean){
    if(!createApartment) this.dtIsRecording= true
    else this.dtIsRecordingCreateApartment= true

    if(this.isUpdateAction){
        this.storeUpdateBlock()
            .then(( updatedBlock: IBlock )=>{
              this.dtBlockModalVisible= false
            })
            .catch(err=>{
              this.dtError= err
              this.dtErrorModalVisible= true
            })
            .finally(()=> this.dtIsRecording= false )
    }
    else
      return this.storeRecordBlock()
          .then( ( createdBlock: IBlock ) => {
            this.dtBlockModalVisible= false
            console.log('created new new block',createdBlock)
            return Promise.resolve(createdBlock.id)
          })
          .catch(error=>{
            this.dtError= error
            this.dtErrorModalVisible= true
          })
          .finally(()=>{
            if(!createApartment) this.dtIsRecording= false
            else this.dtIsRecordingCreateApartment= false
          })
  }

  handleSaveMaintenance()
  {
    this.dtIsRecording= true
    eventBus.$emit('SET_ISLOADING_MODAL_MAINTENANCE',true)
    if(!this.isUpdateMaintenance)
    {
      console.log('save maintenance')
      this.storeCreateMaintenance().then(createdMaintenance=>{
        eventBus.$emit('RELOAD_BLOCK_DASHBORD',this.$route.params.id)
        console.log({createdMaintenance})
        this.dtMaintenanceModalVisible = false
        this.storeMaintenanceInitFields()
        this.$router.push(
          {
            path:`/block/${this.$route.params.id}/maintenance/${createdMaintenance.id}`,
            params: {
              id: this.$route.params.id,
              cid: createdMaintenance.id
            }
          },()=>{
            // onComplete
            eventBus.$emit('RELOAD_MAINTENANCE_AFTER_UPDATE', createdMaintenance)
          }
        )
      }).catch(error=>{
        console.log({error})
      }).finally(()=>{
        this.dtIsRecording= false
      })
    }
    else
    {
      console.log('update maintenance', this.maintenanceData)
      this.storeUpdateMaintenance(this.maintenanceData.id).then(updatedMaintenance=>{
        console.log({updatedMaintenance})
        this.maintenanceData = null
        this.isUpdateMaintenance = false
        this.dtMaintenanceModalVisible = false
        this.storeMaintenanceInitFields()
        /* this.$router.push(
          {
            path:`/block/${this.$route.params.id}/maintenance/${updatedMaintenance.id}`,
            params: {
              id: this.$route.params.id,
              cid: updatedMaintenance.id
            }
          }
        ) */
        eventBus.$emit('RELOAD_MAINTENANCE_AFTER_UPDATE', updatedMaintenance)
      }).catch(error=>{
        console.log({error})
      }).finally(()=>{
        this.dtIsRecording= false
      })
    }
  }

  handleSaveEquipment(changeDisable: boolean = false) {
    this.dtIsRecording= true
    if (this.isUpdateAction) {
      if (changeDisable) {
        this.storeAssignValueForEquipment({disable: !this.currentEquipment.disable})
      }
      this.storeUpdateEquipment()
        .then(response => {
          this.dtEquipmentModalVisible = false
        })
        .catch(err=>{
          this.dtError= err
          this.dtErrorModalVisible= true
        })
        .finally(()=>{
          this.dtIsRecording= false
        })
    } else {
      this.storeRecordEquipment()
        .then(response => {
          eventBus.$emit('RELOAD_BLOCK_DASHBORD',this.$route.params.id)
          this.dtEquipmentModalVisible = false
          /* this.$router.push({
            path: `/block/${this.$route.params.id}/equipment/${response.id}`,
            params: {
              id: this.$route.params.id,
              cid: response.id
            }
          }) */
          let routeToGo = response.fk_character_problem_lvl1 === 238 ? 'block_vehicle_details' : 'block_equipment_details'
          this.$router.push({name:routeToGo,params:{id: this.$route.params.id, cid: response.id}})
        })
        .catch(err=>{
          this.dtError= err
          this.dtErrorModalVisible= true
        })
        .finally(()=>{
          this.dtIsRecording= false
        })
    }
  }

  handleSaveApartment(){
    this.dtIsRecording= true
    if(this.isUpdateAction){
      this.storeUpdateApartment()
        .then( (updatedApartment: IApartment) =>{
          this.dtApartmentModalVisible= false
        })
        .catch(err=>{
          this.dtErrorModalVisible= true
          this.dtError= err
        })
        .finally(()=> this.dtIsRecording= false )
    }
    else{
      this.storeRecordApartment({ keepAlive: this.dtApartmentCreateAnother })
        .then(( createdApartment: IApartment )=>{
          if(this.dtApartmentCreateAnother){
            this.dtApartmentCreateAnother= false
            this.dtSuccess= true
            setTimeout(()=> this.dtSuccess= false,7000)
            return
          }
          this.dtApartmentModalVisible= false
        })
        .catch(err=>{
          this.dtError= err
          this.dtErrorModalVisible= true
        })
        .finally(()=>{
          this.dtIsRecording= false
        })
    }
  }

  handleSaveAndCreateAppartments(){
    const _ref = this.$refs['create-block-modal']
    const _formRef = (_ref as any).$refs['form']

    if(_formRef && (_formRef as any).validate() ){
      this.handleSaveBlock(true)
        .then(( blockId: number )=>{
          setTimeout(()=> this.handleAddApartment(blockId),400)
        })
    }
  }

  handleSaveMember() {
    this.dtIsRecording= true
    this.storeUpdateMember()
         .then( response =>{
            this.dtProfileModalVisible= false
            this.$router.go(0)
         })
         .catch(err => {
           this.dtError= err
           this.dtErrorModalVisible= true
         })
         .finally(()=> this.dtIsRecording= false )
  }

  handleBeforeModalClose(){
    if(this.dtBlockModalVisible){
      setTimeout(()=> this.storeResetBlock(), 300)
      this.dtBlockModalVisible= false
    }

    if(this.dtApartmentModalVisible){
      setTimeout(()=> this.storeResetApartment(), 300)
      this.dtApartmentModalVisible= false
    }

    if(this.dtProfileModalVisible){
      setTimeout(()=> this.storeResetMember(),300)
      this.dtProfileModalVisible= false
    }

    if(this.dtEquipmentModalVisible){
      setTimeout(()=> this.storeResetEquipment(),300)
      this.dtEquipmentModalVisible= false
    }

    if(this.dtMaintenanceModalVisible){
      setTimeout(()=> this.storeMaintenanceInitFields(),300)
      console.log('handleBeforeModalClose')
      this.maintenanceData = null
      this.isUpdateMaintenance = false
      this.dtMaintenanceModalVisible= false
    }
  }


  /* closeMaintenanceModal(){
    this.dtMaintenanceModalVisible = false
  } */

  handleClose(){}

  onCreateAppartments(){}

  handleRemoveError(){
    this.dtErrorModalVisible = false
    this.dtError = null;
  }
}

export default BlockContainer;



// WEBPACK FOOTER //
// ./src/containers/block/index.ts